//--------------- IMPORTAÇÕES ---------------//
import api from "../../../shared/services/api";
import { toast } from "react-toastify";


//--------------- FUNÇÃO ASSÍNCRONA SALVAR EMPRESA ---------------//
// Responsável por salvar a empresa criada via API
export default async function importBatchService(data) {
    try {
        const response = await api.post("/leads/importar-lote", data);
        toast.success("Importação realizada com sucesso");
        return response;
    } catch {
        toast.error("Erro ao importar lote de leads");
        return null;
    }
}